<template>
  <div class="wrapbox">
    <app-bar
      style="height: 0"
      position="top"
      :data-id="this.$route.query.id"
      data-type="42"
    ></app-bar>

    <div class="video" :class="!isShowBuy ? 'z-index' : ''">
      <video
        id="myvideo"
        class="mp4"
        :src="sourceUrl"
        :muted="muteStatus"
        :autoplay="playStatus"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
        playsinline
        webkit-playsinline
        preload
        controls
        v-show="(isPlay && isTry) || (isPlay && !islook)"
      >
        your browser does not support the video tag
      </video>

      <div v-show="(!isPlay && !isTry) || (!isPlay && islook)">
        <div class="MP4img">
          <img :src="poster" alt />
        </div>
        <div v-if="!isTry && islook" @click="_toBuyCourse" class="m-bg">
          <div class="tx">该课程需购买才能观看</div>
          <div @click="_toBuyCourse" class="btn">购买课程</div>
        </div>

        <div
          v-if="
            isTry ||
            (detailsinfo.courseUserProgress &&
              detailsinfo.courseUserProgress.hasBuy)
          "
          v-on:click="playClick()"
          class="btnplay"
        >
          <img src="../../assets/img/icon_play.png" />
        </div>
      </div>
    </div>
    <!-- 目录切换 -->
    <div class="tab" :class="!isShowBuy ? 'z-index' : ''">
      <div
        data-tab="0"
        class="nav"
        @click="_navtab"
        :class="{ a: navtype == 0 }"
      >
        介绍
      </div>
      <div
        data-tab="1"
        class="nav"
        @click="_navtab"
        :class="{ a: navtype == 1 }"
      >
        目录
      </div>
      <div
        data-tab="2"
        class="nav"
        @click="_navtab"
        :class="{ a: navtype == 2 }"
      >
        互动区
      </div>
    </div>
    <!-- 课程介绍 -->
    <div v-if="navtype == 0" class="tabbox" :class="isIphoneX ? 'ac' : ''">
      <div class="title">
        <div
          v-if="detailsinfo.courseInfo && detailsinfo.courseInfo.tag"
          class="title_sale"
        >
          <div class="text">限时特惠</div>
        </div>
        {{ detailsinfo.courseInfo ? detailsinfo.courseInfo.name : '' }} |
        {{ detailsinfo.courseInfo ? detailsinfo.courseInfo.teacherTitle : '' }}
        {{ detailsinfo.courseInfo ? detailsinfo.courseInfo.teacher : '' }}
      </div>
      <div class="price" v-if="detailsinfo.goodInfoTo">
        {{ detailsinfo.goodInfoTo.goodInfo.sellPrice }}
        <div class="orp">{{ detailsinfo.goodInfoTo.goodInfo.originPrice }}</div>
      </div>
      <div class="line"></div>
      <div class="main">
        <div
          class="t-c"
          v-if="detailsinfo.courseDetail"
          v-html="detailsinfo.courseDetail.detail"
        ></div>
      </div>
    </div>
    <!-- 目录 -->
    <div v-if="navtype == 1" class="tabbox" :class="isIphoneX ? 'ac' : ''">
      <div
        v-for="(item, index) in detailsinfo.courseChapterVoList"
        :key="index"
      >
        <div class="wraplist">
          <div :data-index="index" @click="_taggle" class="c_title">
            <div :data-index="index" v-if="item.courseChapter" class="text">
              {{ item.courseChapter.name ? item.courseChapter.name : '' }}
            </div>
            <img
              :data-index="index"
              :class="item.courseChapter.isShow ? '' : 'ra'"
              src="../../assets/img/arrow.png"
              alt
            />
          </div>
        </div>
        <div v-if="item.courseChapter.isShow" class="c_list">
          <div
            v-for="(it, ix) in item.courseLessonList"
            :key="ix"
            :data-urlimg="it.imageUrl"
            :data-video="
              it.courseLessonOriginInfo
                ? it.courseLessonOriginInfo.originUrl
                : it.sourceUrl
            "
            :data-publish="it.isPublish"
            @click="_openCourse($event, it.isTry, it.courseLessonOriginInfo)"
            class="t"
            :class="poster == it.imageUrl ? 'a' : ''"
          >
            <div
              :data-urlimg="it.imageUrl"
              :data-video="
                it.courseLessonOriginInfo
                  ? it.courseLessonOriginInfo.originUrl
                  : it.sourceUrl
              "
              data-publish="it.isPublish"
              @click="_openCourse($event, it.isTry, it.courseLessonOriginInfo)"
              class="name"
            >
              {{ it.name }}
            </div>
            <div
              :data-urlimg="it.imageUrl"
              :data-video="
                it.courseLessonOriginInfo
                  ? it.courseLessonOriginInfo.originUrl
                  : it.sourceUrl
              "
              data-publish="it.isPublish"
              @click="_openCourse($event, it.isTry, it.courseLessonOriginInfo)"
              v-if="it.sourceDuration"
              class="time"
            >
              <div
                v-if="
                  !it.isPushish &&
                  detailsinfo.courseUserProgress &&
                  detailsinfo.courseUserProgress.hasBuy &&
                  !it.isPublish
                "
                :data-urlimg="it.imageUrl"
                :data-video="
                  it.courseLessonOriginInfo
                    ? it.courseLessonOriginInfo.originUrl
                    : it.sourceUrl
                "
                data-publish="it.isPublish"
                @click="
                  _openCourse($event, it.isTry, it.courseLessonOriginInfo)
                "
                class="isPublish"
              >
                <img
                  class="isPublishimg"
                  src="../../assets/img/icon_y.png"
                  alt
                />
                {{ formatDate(it.publishTime) }}
              </div>

              <div v-else class="isPublish">
                <img class="time" src="../../assets/img/icon_time.png" alt />
                {{ MillisecondToDate(it.sourceDuration) }}
              </div>
            </div>
            <div
              v-if="
                (it.isTry && !detailsinfo.courseUserProgress) ||
                (it.isTry &&
                  detailsinfo.courseUserProgress &&
                  !detailsinfo.courseUserProgress.hasBuy)
              "
              class="look"
            >
              试看
            </div>
            <img
              v-else-if="
                (!it.isTry && !detailsinfo.courseUserProgress) ||
                (detailsinfo.courseUserProgress &&
                  !detailsinfo.courseUserProgress.hasBuy)
              "
              src="../../assets/img/lock.png"
              alt
              class="iss"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- 互动区 -->
    <div
      v-if="navtype == 2"
      class="tabbox u_list"
      :class="isIphoneX ? 'ac' : ''"
    >
      <!-- <mt-loadmore
          :bottom-method="loadBottom"
          :bottom-all-loaded="bottomAllLoaded"
          bottomPullText
          bottomDropText
          bottomLoadingText
          :bottomDistance="100"
          ref="loadmore"
          >-->
      <div v-for="(item, index) in zone" :key="index" class="hd_list">
        <div @click="_goUserinfo(item.userDetailInfo.id)" class="tx">
          <img :src="item.userDetailInfo.logoUrl" alt />
        </div>
        <div
          class="right"
          :class="index == zone.length - 1 ? 'last' : ''"
          @click="_goDetails(item.noteInfo.id)"
        >
          <div class="r_info">
            <div class="r_name">{{ item.userDetailInfo.nickName }}</div>
            <div class="r_date">{{ item.userDetailInfo.registerTime }}</div>
          </div>
          <div class="r_desc">{{ item.noteContent.content }}</div>
          <div v-if="item.notePhotos == [] ? false : true" class="r_img">
            <swiper :options="swiperOption" ref="mySwiper" class="good-banner">
              <swiper-slide v-for="(i, inx) in item.notePhotos" :key="inx">
                <img :src="i.imageUrl" alt />
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
      <!-- </mt-loadmore> -->
    </div>

    <div class="footer" :class="isIphoneX ? 'iphonex' : ''">
      <div
        v-if="
          detailsinfo.courseUserProgress &&
          detailsinfo.courseUserProgress.hasBuy
        "
        class="study_btn"
      >
        已学{{ detailsinfo.courseUserProgress.lessonLearnCount }}节/{{
          detailsinfo.courseInfo.lessonCount
        }}节
      </div>
      <div v-else @click="_toBuyCourse" class="study_btn">立即学习</div>
      <buy-cell
        v-if="isShowBuy"
        value="value"
        @input="closeAlert"
        :sku-list="detailsinfo.goodInfoTo.goodStockList"
        :is_redirect="is_redirect"
      ></buy-cell>
    </div>
  </div>
</template>
<script>
import BuyCell from '@/components/BuyCell'
import AppBar from '@/components/AppBar'
import { getCourseDetails, getNote } from '@/api/courseDetails'
// import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { getIsIphonex } from '@/utils/utils'
import { Loadmore } from 'mint-ui'
import { getTokenUser } from '@/api/base'
import { setTimeout } from 'timers'
import * as utils from '@/utils/utils'
import { constants } from 'fs'
import { share } from '@/utils/share'
export default {
  name: 'courseDetails',
  components: { swiper, swiperSlide, BuyCell, AppBar },
  metaInfo: { title: '课程详情' },
  data() {
    return {
      sourceUrl: '',
      poster: '',
      playStatus: false,
      isIphoneX: false,
      muteStatus: '',
      isMute: true,
      isPlay: false,
      islook: true,
      isTry: false,
      hasOrigin: false,
      is_redirect: true,
      navtype: 0,
      detailsinfo: {},
      isload: false,
      zone: [],
      indexpage: 1,
      swiperOption: {
        slidesPerView: 4,
        centeredSlides: false,
        mousewheel: true,
      },
      queryId: '',
      bottomAllLoaded: true,
      bottomText: '上拉加载更多...',
      userInfo: null,
      value: true,
      isShowBuy: false,
      myScroll: null,
      listHeight: 0,
      listScrollTop: 0,
      isapbar: false,
      ispost: true,
      contentH: 0,
    }
  },
  methods: {
    // 获取用户信息
    getUser() {
      getTokenUser().then((res) => {
        this.userInfo = res.data
      })
    },
    getCourseDetails() {
      let obj = {
        id: this.$route.query.id,
      }
      getCourseDetails(obj).then((res) => {
        for (let i = 0; i < res.data.courseChapterVoList.length; i++) {
          res.data.courseChapterVoList[i].courseChapter.isShow = true
        }
        this.detailsinfo = res.data
        this.isload = true
        share(res.data.shareCard)
        this._getTestvideo()
      })
    },
    _getTestvideo() {
      let is = this.detailsinfo.courseChapterVoList[0].courseLessonList[0]
      let l = this.detailsinfo.courseChapterVoList
      if (is.isTry) {
        this.sourceUrl = is.originUrl || is.sourceUrl
        this.poster = is.imageUrl
        this.isTry = is.isTry
        return
      }
      for (let i = 0; i < l.length; i++) {
        for (let j = 0; j < l[i].courseLessonList.length; j++) {
          if (l[i].courseLessonList[j].isTry) {
            this.sourceUrl =
              l[i].courseLessonList[j].originUrl ||
              l[i].courseLessonList[j].sourceUrl
            this.poster = l[i].courseLessonList[j].imageUrl
            this.isTry = l[i].courseLessonList[j].isTry
            return
          }
        }
      }

      this.sourceUrl = ''
      this.poster = is.imageUrl
    },
    playClick() {
      if (
        this.detailsinfo.courseUserProgress &&
        this.detailsinfo.courseUserProgress.hasBuy &&
        !this.isTry &&
        !this.hasOrigin
      ) {
        this.$toast('请点击前往App观看')
        this.isapbar = true
        return
      }

      this.isPlay = true
      this._dom = document.getElementById('myvideo')
      this._dom.play()
    },
    _navtab(e) {
      if (e === '2') {
        this.navtype = '2'
      } else {
        this.navtype = e.target.getAttribute('data-tab')
      }
      if (this.navtype === '2') {
        let obj = {
          dataId: this.$route.query.id,
          dataType: 42,
          page: { index: this.indexpage, size: 10 },
        }
        getNote(obj).then((res) => {
          let morelist = []
          if (res.data.list && res.data.list.length > 0) {
            morelist = res.data.list
            if (res.data.next.index > this.indexpage && this.indexpage !== 1) {
              morelist = this.zone.concat(morelist)
            }
            this.zone = morelist
            this.indexpage = res.data.next.index
            // this.bottomAllLoaded = false
          }
          this.ispost = true
          // if (!res.data.list < 1) {

          //   this.bottomAllLoaded = true
          //   this.$refs.loadmore.onBottomLoaded()
          // }
        })
      }
    },
    _openCourse(e, isTry, courseLessonOriginInfo) {
      console.log(1)
      this.isapbar = false
      let islook = true
      let img = e.target.getAttribute('data-urlimg')
      let video = e.target.getAttribute('data-video')
      let isPublish = e.target.getAttribute('data-publish')
      if (img === null) {
        img = 'https://img.zai-art.com/d39876b7ad0a49058763ff0852cb860b.jpg'
      }
      if (
        this.detailsinfo.courseUserProgress &&
        this.detailsinfo.courseUserProgress.hasBuy &&
        !isTry
      ) {
        islook = false
      }
      this.sourceUrl = video
      this.poster = img
      this.isPlay = false
      this.isTry = isTry
      this.islook = islook
      this.hasOrigin =
        courseLessonOriginInfo && courseLessonOriginInfo.originUrl

      if (!isPublish) {
        if (
          this.detailsinfo.courseUserProgress &&
          this.detailsinfo.courseUserProgress.hasBuy
        )
          this.$toast('该节课程尚未更新')
        return
      }
    },
    _goDetails(e) {
      window.location.href = `https://gw.zai-art.com/appwrapper/appShare/notes.html?id=${e}`
    },
    _goUserinfo(e) {
      window.location.href = `https://gw.zai-art.com/appwrapper/appShare/home.html?id=${e}`
    },
    _taggle(e) {
      let index = e.target.getAttribute('data-index')
      if (this.detailsinfo.courseChapterVoList[index].courseChapter.isShow) {
        this.detailsinfo.courseChapterVoList[index].courseChapter.isShow = false
      } else {
        this.detailsinfo.courseChapterVoList[index].courseChapter.isShow = true
      }
    },
    getIsIphonex,
    loadBottom() {
      this._navtab('2')
    },
    // 立即学习
    _toBuyCourse() {
      this.isShowBuy = true
    },
    closeAlert() {
      this.isShowBuy = false
    },
    MillisecondToDate(msd) {
      var hours = parseInt((msd % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      var minutes = parseInt((msd % (1000 * 60 * 60)) / (1000 * 60))
      var seconds = parseInt((msd % (1000 * 60)) / 1000)
      hours = hours < 10 ? '0' + hours : hours
      minutes = minutes < 10 ? '0' + minutes : minutes
      seconds = seconds < 10 && seconds >= 1 ? '0' + seconds : seconds
      if (hours === '00') {
        return minutes + ':' + seconds
      }
      return hours + ':' + minutes + ':' + seconds
    },
    formatDate(now) {
      var d = new Date(now)
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      month = month < 10 ? '0' + month : month
      var date = d.getDate()
      date = date < 10 ? '0' + date : date
      var hour = d.getHours()
      var minute = d.getMinutes()
      var second = d.getSeconds()
      return year + '-' + month + '-' + date
    },
    handleScroll(e) {
      let scrollTop =
        e.target.body.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      let height =
        document.documentElement.clientHeight || document.body.clientHeight
      let h = height + scrollTop + 5
      if (h > e.target.body.scrollHeight) {
        if (this.navtype === '2' && this.ispost) {
          this.ispost = false
          console.log('ddd')
          this._navtab('2')
        }
      }
    },
  },
  created() {
    this.isIphoneX = this.getIsIphonex()
    this.queryId = this.$route.query.id || this.$route.params.id
    this.getCourseDetails()
    // this.getUser()
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    // this.contentH = document.documentElement.clientHeight
    var buttons = document.querySelectorAll('.js-goApp')
    if (window.Mlink) {
      try {
        this.mlink = new window.Mlink({
          mlink: 'AAyN',
          button: buttons,
          autoLaunchApp: false,
          autoRedirectToDownloadUrl: true,
          downloadWhenUniversalLinkFailed: true,
          inapp: false,
          params: {
            dataId: this.dataId,
            dataType: this.dataType,
            dataTitle: '',
          },
        })
      } catch (e) {}
    } else {
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].addEventListener(
          'click',
          () => {
            location.href =
              'http://a.app.qq.com/o/simple.jsp?pkgname=com.zaiart.yi'
          },
          false
        )
      }
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
}
</script>

<style  src='@/assets/css/details.css'></style>
